import React, { Component } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';
import LoadingComponent from '../../components/common/LoadingComponent';
import NewBenefitsCard from '../../components/policy/newBenefitsCard';
import { BoldText, Text, SemiBoldText } from '../../components/common/Text';
import NewClaimsCard from '../../components/policy/NewClaimsCard';
import NewHelpCard from '../../components/policy/NewHelpCard';
import { InsureTabApi } from '../../services';
import { Carousel } from 'react-responsive-carousel';
import { setCurrentActiveTab } from '../../actions';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  height: 90vh;
  background: #ffffff;
  overflow: hidden;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  background: white;
`;

const Body = styled.div`
  width: 90%;
  margin: auto;
  //margin-top: 1rem;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: 2rem;
  overflow-x: hidden;
`;

const HeaderContainer = styled.div`
  // position: fixed;
  // top: 0px;
  // left: 0px;
  // width: 100%;
  // display: flex;
  // flex-direction: column;
  // padding: 30px 0 18px;
  // align-self: stretch;
  // align-items: center;
  // justify-content: center;
  // border-bottom: 1px solid #f0f3f6;
  // background-color: white;

  display: flex;
  flex-direction: column;
  padding: 30px 0 18px;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f3f6;
  @media (min-width: 1024px) {
    display: none;
  }
`;

const Header = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const HeaderText = styled(BoldText)`
  font-size: 16px;
  text-align: center;
  font-family: Inter;
  font-weight: 600;
`;
const SectionHeading = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 1rem;
`;
const Session = styled.div`
  margin-top: 1rem;
  border-bottom: 2px solid #e6e9ec;
`;
const styledElement = document.getElementsByClassName('carousel-root');

class NewInsureTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      insured: false,
      opdPolicies: [],
      ipdPolicies: [],
      claims: [],
      opdWalletDetails: [],
      policyDetails: {},
      policySavings: {},
      reimbursementRequests: null,
      coiUrl: null,
      activeTabIndex: 0,
      activeTab: '',
      opdDependentWallet: [],
      dependentSelectedWallet: {},
      opdEcards: [],
      benefitsSection: [],
      claimsSection: [],
      helpSection: [],
      offersSection: [],
    };
  }

  Header() {
    return (
      <HeaderContainer>
        <Header>
          <HeaderText>My Policies</HeaderText>
        </Header>
      </HeaderContainer>
    );
  }
  getAppropriateRoute(key, policyId) {
    //console.log('function is accessed');
    switch (key) {
      case 'OPD':
        return this.props.history.push(
          '/home/insure/opd-benefits?hidetabs=true',
          {
            policyId,
          }
        );
      case 'help':
        return this.props.history.push('/home/insure/faq?hidetabs=true');
      case 'GMC':
        return this.props.history.push(
          '/home/insure/ipd-benefits?hidetabs=true',
          {
            policyId,
          }
        );
      default:
        return '';
    }
  }

  renderBody() {
    return (
      <div>
        {this.state &&
          this.state.benefitsSection &&
          this.state.benefitsSection.length > 0 && (
            <Session>
              <SectionHeading>Benefits</SectionHeading>
              {this.state.benefitsSection.map((item) => (
                <NewBenefitsCard
                  key={item.policyId}
                  data={item}
                  onTap={() =>
                    this.getAppropriateRoute(item.type, item.policyId)
                  }
                />
              ))}
            </Session>
          )}
        {/* {
          <CarouselOuterContainer>
            <Carousel
              showIndicators={true}
              showStatus={false}
              centerMode={true}
              centerSlidePercentage="100"
            >
              {this.state.opdEcards &&
                this.state.opdEcards.map((eCard) => {
                  return (
                    <CardDiv key={eCard.age}>
                      <CardHeader>
                        <CardInsurerLogoContainer>
                          <img src={eCard.insurerLogo} />
                        </CardInsurerLogoContainer>
                        <CardTitle>OPD E-Card</CardTitle>
                      </CardHeader>
                      <CardData>
                        <CardPtag>Member Name</CardPtag>

                        <CardPtag2>{eCard.memberName}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Age</CardPtag>

                        <CardPtag2>{eCard.age}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Policy Number</CardPtag>

                        <CardPtag2>{eCard.policyNumber}</CardPtag2>
                      </CardData>
                      <CardData>
                        <CardPtag>Valid Till</CardPtag>

                        <CardPtag2>{eCard.validTill}</CardPtag2>
                      </CardData>
                      <CardFooter>
                        <CardSponsorLogoContainer>
                          <CardPtag>Corporate Name</CardPtag>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'left',
                            }}
                          >
                            <img
                              src={eCard.sponsorLogo}
                              style={{ width: '68%' }}
                            />
                          </div>
                        </CardSponsorLogoContainer>
                      </CardFooter>
                    </CardDiv>
                  );
                })}
            </Carousel>
          </CarouselOuterContainer>
        } */}

        {this.state &&
          this.state.claimsSection &&
          this.state.claimsSection.length > 0 && (
            <Session>
              <SectionHeading>Claims</SectionHeading>
              {this.state.claimsSection.map((item) => (
                <NewClaimsCard
                  data={item}
                  onTap={() => this.props.history.push('/claims')}
                />
              ))}
            </Session>
          )}
        {this.state &&
          this.state.helpSection &&
          this.state.helpSection.length > 0 && (
            <Session>
              <SectionHeading>Help</SectionHeading>
              {this.state.helpSection.map((item) => (
                <NewHelpCard
                  data={item}
                  onTap={() => this.getAppropriateRoute(item.themeKey)}
                />
              ))}
            </Session>
          )}
      </div>
    );
  }
  fetchData() {
    const { authToken } = this.props;
    //console.log('this props are', this.props);

    InsureTabApi(authToken)
      .then((data) => {
        //console.log('responce is ', data);
        data &&
          data.sections &&
          data.sections.forEach((item) => {
            if (item.key === 'benefits') {
              this.setState({ benefitsSection: item.cards });
            } else if (item.key === 'claims') {
              this.setState({ claimsSection: item.cards });
            } else if (item.key === 'help') {
              this.setState({ helpSection: item.cards });
            } else if (item.key === 'offers') {
              this.setState({ offersSection: item.cards });
            }
          });
      })
      .catch((err) => console.log('err is', err))
      .finally(() => this.setState({ loading: false }));
  }

  componentDidMount() {
    if (this.props.loginState !== 'LOGGED_IN' || !this.props.authToken) {
      this.props.history.push('/');
    } else {
      this.fetchData();
    }
    //this.props.dispatch(setCurrentActiveTab('insure'));
    //const data = this.mockData();
    //const opdData = this.OpdCardData();
    //this.setState({ opdEcards: opdData.opdPolicies.eCards });
    //console.log('opddata is ', opdData);
    //this.setState({ loading: false });
  }
  render() {
    return !this.state.loading ? (
      // <OuterContainer>
      //   {this.Header()}
      //   <BodyContainer>
      //     <Body>{this.renderBody()}</Body>
      //   </BodyContainer>
      // </OuterContainer>
      <OuterContainer>
        {this.Header()}
        <BodyContainer>
          <Body>{this.renderBody()}</Body>
        </BodyContainer>
      </OuterContainer>
    ) : (
      <LoadingComponent />
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  profileImage: state.user.profileImage,
  sponsorId: state.user.sponsorId,
  showSubscription: state.app.config.showSubscription,
  showOPD: state.app.config.showOPD,
  insured: state.app.config.insured,
  subscribed: state.app.config.subscribed,
});

export default connect(mapStateToProps)(NewInsureTab);

const CardDiv = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #d9d9d9;
  border-radius: 20px;
  margin-right: 2rem;
`;
const CardHeader = styled.div`
  display: flex;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  justify-content: space-between;
  align-items: center;
  background: #f5f4ff;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;
const CardData = styled.div`
  display: flex;
  justify-content: space-between;
  width:85%
  margin:auto;
  padding-top: 1rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #E6E9EC;
  
`;
const CardInsurerLogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 55px;
  height: 55px;
`;
const CardSponsorLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 80px;
  height: 45px;
`;
const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  align-items: center;
  background: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
`;
const CardTitle = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
`;
const CardPtag = styled.p`
  display: flex;
  align-items: center;
  color: #666;
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: normal;
`;
const CardPtag2 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
`;
const CarouselOuterContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
